export const STATUS_CONFIG = {
  available: {
    label: 'Available',
    kpiLabel: 'Available Trucks',
    kpiHint: 'Ready to dispatch',
    className: 'bg-emerald-500/15 text-emerald-700 ring-emerald-500/30',
    kpiBg: 'from-emerald-600/20 to-emerald-500/5 border-emerald-200',
    kpiIcon: 'check',
    rowMuted: false,
  },
  loading: {
    label: 'Loading',
    kpiLabel: 'Loading',
    kpiHint: 'At refineries / depots',
    className: 'bg-orange-500/15 text-orange-700 ring-orange-500/30',
    kpiBg: 'from-orange-600/20 to-orange-500/5 border-orange-500/30',
    kpiIcon: 'loader',
    rowMuted: false,
  },
  transit: {
    label: 'In Transit',
    kpiLabel: 'Transit',
    kpiHint: 'On the road',
    className: 'bg-logi-accent/100/15 text-blue-700 ring-blue-500/30',
    kpiBg: 'from-blue-600/20 to-logi-silver0/5 border-blue-500/30',
    kpiIcon: 'route',
    rowMuted: false,
  },
  maintenance: {
    label: 'Maintenance',
    kpiLabel: 'Maintenance',
    kpiHint: 'In the workshop',
    className: 'bg-red-500/15 text-red-700 ring-red-500/30',
    kpiBg: 'from-red-600/20 to-red-500/5 border-red-200',
    kpiIcon: 'wrench',
    rowMuted: true,
  },
  expired_documents: {
    label: 'Expired Docs',
    kpiLabel: 'Expired Documents',
    kpiHint: 'Grounded — Mulkiya / ADNOC',
    className: 'bg-purple-500/15 text-purple-400 ring-purple-500/30',
    kpiBg: 'from-purple-700/25 to-red-900/10 border-purple-500/30',
    kpiIcon: 'alert',
    rowMuted: true,
  },
  idle: {
    label: 'Idle',
    kpiLabel: 'Idle Vehicles',
    kpiHint: 'Free · no driver / trip',
    className: 'bg-yellow-500/15 text-yellow-700 ring-yellow-500/30',
    kpiBg: 'from-yellow-600/15 to-amber-500/5 border-yellow-500/30',
    kpiIcon: 'pause',
    rowMuted: false,
  },
  upcoming: {
    label: 'Upcoming',
    kpiLabel: 'Upcoming Availability',
    kpiHint: 'Finishing trip ≤2 hrs',
    className: 'bg-teal-500/15 text-teal-400 ring-teal-500/30',
    kpiBg: 'from-teal-600/20 to-blue-400/5 border-teal-500/30',
    kpiIcon: 'clock',
    rowMuted: false,
  },
};

export const FLEET_READINESS = [
  {
    id: 'VH-101',
    vehicleNumber: 'DXB-T-4021',
    vehicleType: 'Fuel Tanker',
    location: 'Jebel Ali Depot — Bay 4',
    capacity: '42 KL',
    status: 'available',
    driverName: 'Ahmed Al Mansoori',
    driverStatus: 'Checked-In',
  },
  {
    id: 'VH-102',
    vehicleNumber: 'SHJ-C-8810',
    vehicleType: 'Chemical Tanker',
    location: 'Sharjah Refinery — Loading Zone A',
    capacity: '38 MT',
    status: 'loading',
    driverName: 'Rajesh Kumar',
    driverStatus: 'Checked-In',
  },
  {
    id: 'VH-103',
    vehicleNumber: 'AUH-L-1155',
    vehicleType: 'LPG Trailer',
    location: 'E311 — En Route to Sharjah',
    capacity: '56 KL',
    status: 'transit',
    driverName: 'Mohammed Hassan',
    driverStatus: 'On Trip',
  },
  {
    id: 'VH-104',
    vehicleNumber: 'DXB-F-2208',
    vehicleType: 'Fuel Tanker',
    location: 'Al Quoz Workshop',
    capacity: '40 KL',
    status: 'maintenance',
    driverName: '—',
    driverStatus: 'Unassigned',
  },
  {
    id: 'VH-105',
    vehicleNumber: 'AUH-B-3340',
    vehicleType: 'Bitumen Tanker',
    location: 'Mussafah Yard — Grounded',
    capacity: '32 MT',
    status: 'expired_documents',
    driverName: 'Khalid Al Zaabi',
    driverStatus: 'Rest-Period',
  },
  {
    id: 'VH-106',
    vehicleNumber: 'DXB-T-5590',
    vehicleType: 'Fuel Tanker',
    location: 'Dubai Industrial City — Standby',
    capacity: '45 KL',
    status: 'idle',
    driverName: '—',
    driverStatus: 'No Driver',
  },
  {
    id: 'VH-107',
    vehicleNumber: 'RUW-G-7721',
    vehicleType: 'Fuel Tanker',
    location: 'Habshan — Unloading Complete',
    capacity: '48 KL',
    status: 'upcoming',
    driverName: 'Yusuf Ibrahim',
    driverStatus: 'Checked-In',
    etaMinutes: 90,
  },
  {
    id: 'VH-108',
    vehicleNumber: 'DXB-C-9012',
    vehicleType: 'Chemical Tanker',
    location: 'Jebel Ali Port — Gate 7',
    capacity: '35 MT',
    status: 'loading',
    driverName: 'Sanjay Patel',
    driverStatus: 'Checked-In',
  },
  {
    id: 'VH-109',
    vehicleNumber: 'SHJ-T-4410',
    vehicleType: 'Fuel Tanker',
    location: 'Sharjah Industrial — Available Bay',
    capacity: '41 KL',
    status: 'available',
    driverName: 'Yusuf Ibrahim',
    driverStatus: 'Checked-In',
  },
  {
    id: 'VH-110',
    vehicleNumber: 'AUH-L-6688',
    vehicleType: 'LPG Trailer',
    location: 'E102 — Approaching Abu Dhabi',
    capacity: '52 KL',
    status: 'transit',
    driverName: 'Ahmed Al Mansoori',
    driverStatus: 'On Trip',
  },
  {
    id: 'VH-111',
    vehicleNumber: 'DXB-P-1122',
    vehicleType: 'Bulk Powder Tanker',
    location: 'JAFZA Depot — Idle Lane',
    capacity: '28 MT',
    status: 'idle',
    driverName: '—',
    driverStatus: 'No Driver',
  },
  {
    id: 'VH-112',
    vehicleNumber: 'FUJ-T-8834',
    vehicleType: 'Fuel Tanker',
    location: 'Fujairah Port — ETA 1h 45m',
    capacity: '44 KL',
    status: 'upcoming',
    driverName: 'Rajesh Kumar',
    driverStatus: 'On Trip',
    etaMinutes: 105,
  },
  {
    id: 'VH-113',
    vehicleNumber: 'SHJ-T-9901',
    vehicleType: 'Water Tanker',
    location: 'Sharjah Garage — Brake Service',
    capacity: '20 KL',
    status: 'maintenance',
    driverName: '—',
    driverStatus: 'Unassigned',
  },
  {
    id: 'VH-114',
    vehicleNumber: 'DXB-G-4455',
    vehicleType: 'Fuel Tanker',
    location: 'ENOC Terminal — Grounded',
    capacity: '43 KL',
    status: 'expired_documents',
    driverName: 'Mohammed Hassan',
    driverStatus: 'Checked-In',
  },
  {
    id: 'VH-115',
    vehicleNumber: 'AUH-T-7788',
    vehicleType: 'Fuel Tanker',
    location: 'Ruwais Refinery — Loading Bay 2',
    capacity: '46 KL',
    status: 'loading',
    driverName: 'Khalid Al Zaabi',
    driverStatus: 'Checked-In',
  },
];

export function computeStatusCounts(fleet = FLEET_READINESS) {
  const counts = {
    available: 0,
    loading: 0,
    transit: 0,
    maintenance: 0,
    expired_documents: 0,
    idle: 0,
    upcoming: 0,
  };
  fleet.forEach((v) => {
    counts[v.status] = (counts[v.status] || 0) + 1;
  });
  return counts;
}

export const KPI_ORDER = [
  'available',
  'loading',
  'transit',
  'maintenance',
  'expired_documents',
  'idle',
  'upcoming',
];
